import {
  HOTEL_AUTOCOMPLETE_MIN_QUERY_LENGTH,
} from '../constants/hotelSearch.constants';

export function normalizeHotelAutocompleteQuery(query) {
  return String(query ?? '').trim();
}

export function isHotelAutocompleteWhitespaceOnly(query) {
  const raw = String(query ?? '');
  return raw.length > 0 && normalizeHotelAutocompleteQuery(raw).length === 0;
}

export function isHotelAutocompleteQueryReady(query) {
  return normalizeHotelAutocompleteQuery(query).length >= HOTEL_AUTOCOMPLETE_MIN_QUERY_LENGTH;
}

/**
 * Query to POST to search-autocomplete, or null when the frontend must not call.
 * Whitespace-only input never hits the network, including the empty fallback.
 */
export function getHotelAutocompleteRequestQuery(input, { fallbackQuery = null } = {}) {
  if (isHotelAutocompleteWhitespaceOnly(input)) return null;
  const trimmed = normalizeHotelAutocompleteQuery(input);
  if (isHotelAutocompleteQueryReady(trimmed)) return trimmed;
  return fallbackQuery;
}
